/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { Col, Row, Select, Upload } from "antd";
import { Button, Card, Form, Input, Spin } from "antd";
import { displayMessage, getAPI, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import {
  EDIT_USER,
  FILE_DESTROY,
  FILE_UPLOAD,
  IMAGE_BASE_URL,
  LOCATIONS,
  USER_DETAIL,
} from "../../constants/api";
import { USER_TYPE } from "../../constants/constent";
import LS_SERVICE from "../../utils/localStorage";
const { Dragger } = Upload;
const { Option } = Select;

function ProfileUpdateForm() {
  const id = LS_SERVICE.get("id");

  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const [oldDocID, setOldDocID] = useState(null);
  // Locations
  const [country, setCountry] = useState(null);
  const [countryID, setCountryID] = useState(null);
  const [state, setState] = useState(null);
  const [stateID, setStateID] = useState(null);
  const [city, setCity] = useState(null);

  useLayoutEffect(() => {
    getIdDetail();
    
  }, []);

  const handleOnChange = (key, value) => {
    form.setFieldsValue({ [key]: value });
    if (key === "country_id") {
      setCountryID(value);
      getLocations(value, stateID);
    } else if (key === "state_id") {
      setStateID(value);
      getLocations(countryID, value);
    }
  };

  const props = {
    multiple: false,
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      const isAllowedType = allowedTypes.includes(file.type);

      if (!isAllowedType) {
        displayMessage(
          ERROR_MSG_TYPE,
          `${file.name} is not a valid image file (PNG, JPEG, JPG only)`
        );
      } else {
        setFileList([file]);
      }

      return isAllowedType || Upload.LIST_IGNORE;
    },
    fileList,
  };

  const handleUploadDoc = async (value) => {
    try {
      setIsLoading(true);
      const data = new FormData();
      data.append("folder", "Customer-Document");
      Array.from(fileList).forEach((element) => {
        data.append("files[]", element);
      });
      data.append("tag", value.phone);

      const successFn = async function (data) {
        console.log("File to response=> " + data);
        if (data.status === true) {
          let docID = data.responses[0].id || null;
          displayMessage(SUCCESS_MESSAGE, data.message);
          if (docID !== null) {
            console.log("Old Doc ID: ", oldDocID);
            if (
              oldDocID !== undefined &&
              oldDocID !== null &&
              Number.isInteger(Number(oldDocID))
            ) {
              await deleteDoc({ id: oldDocID });
            }
            console.log("Doc Result: ", docID);
            value.id_card_image = docID;
            setImageUrl(data.responses[0].filePath);
            setFileList([]);
            form.setFieldsValue({
              id_card_image: docID,
            });
            updateData(value);
          } else {
            setImageUrl(null);
            displayMessage(ERROR_MSG_TYPE, "Unable to Upload Document");
            return null;
          }
        } else {
          setImageUrl(null);
          displayMessage(ERROR_MSG_TYPE, data.message);
          return null;
        }
      };
      const errorFn = function () {
        setImageUrl(null);
        displayMessage(ERROR_MSG_TYPE, "Unable to Upload Document");
        return null;
      };
      postAPI(FILE_UPLOAD, data, successFn, errorFn);
    } catch (error) {
      setImageUrl(null);
      displayMessage(ERROR_MSG_TYPE, error.message);
      return null;
    }
  };

  const deleteDoc = async (value) => {
    console.log("Delete Doc: ", value);
    const successFn = function (data) {
      if (data.status === true) {
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(FILE_DESTROY, value, successFn, errorFn);
  };
  const getIdDetail = () => {
    setIsLoading(true);
    var data = new FormData();
    data.append("id", id);
    const successFn = async function (data) {
      if (data.status === true) {
        if (
          data.user.image !== undefined &&
          data.user.image !== null &&
          data.user.image.filePath
        ) {
          setOldDocID(data.user.image.id ?? null);
          setImageUrl(data.user.image.filePath ?? null);
        }
        form.setFieldsValue({
          name: data.user.name,
          email: data.user.email,
          phone: data.user.phone,
          user_type: data.user.user_type,
          id_card_type: data.user.id_card_type,
          id_card_number: data.user.id_card_number,
          id_card_image: data.user.image?.id ?? null,
          address: data.user.address,
          country_id: data.user.country_id ?? 102,
          state_id: data.user.state_id ?? null,
          city_id: data.user.city_id ?? null,
        });
        setCountryID(data.user.country_id ?? 102);
        setStateID(data.user.state_id ?? null);
        getLocations(data.user.country_id ?? 102, data.user.state_id ?? null);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    postAPI(USER_DETAIL, data, successFn, errorFn);
  };

  const getLocations = (countryID, stateID) => {
    setIsLoading(true);
    const successFn = function (data) {
      setCountry(data.countries);
      setState(data.states);
      setCity(data.cities);
      setIsLoading(false);
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    const url =
      LOCATIONS +
      (countryID ? countryID : "") +
      (stateID ? `&state_id=${stateID}` : "");
    getAPI(url, successFn, errorFn);
  };

  const formHandle = async (value) => {
    if (fileList.length > 0) {
      await handleUploadDoc(value);
    } else {
      updateData(value);
    }
  };

  const updateData = (values) => {
    setIsLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_USER, values, successFn, errorFn);
  };
  return (
    <>
      <Card title="Profile Update" bordered={false}>
        <Spin spinning={loading}>
          <Form form={form} layout="vertical" onFinish={formHandle}>
            <Form.Item name="id" initialValue={id} hidden />
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={6}>
                <Form.Item
                  name="name"
                  label="Full Name"
                  rules={[
                    {
                      required: true,
                      message: `Name is required!`,
                    },
                    {
                      pattern: /^[a-zA-Z0-9\s,.'-]{3,}$/,
                      message:
                        "Name must be at least 3 characters long and alphanumeric.",
                    },
                  ]}
                >
                  <Input type={"text"} placeholder="Full Name" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: `Email is required!`,
                    },
                    {
                      pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Please enter a valid email address.",
                    },
                  ]}
                >
                  <Input disabled placeholder="Email" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6}>
                <Form.Item
                  name="phone"
                  label="Phone"
                  rules={[
                    {
                      required: true,
                      message: `Phone is required!`,
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Please enter a valid 10-digit phone number.",
                    },
                  ]}
                >
                  <Input placeholder="Phone" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6}>
                <Form.Item
                  name="user_type"
                  label="User Type"
                  rules={[
                    { required: true, message: "User Type is required!" },
                  ]}
                >
                  <Select
                    showSearch
                    disabled
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    placeholder="Select a User Type"
                    optionFilterProp="label"
                    options={USER_TYPE}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6}>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[{ required: false }]}
                >
                  <Input type={"password"} placeholder="Password" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item
                  name="id_card_type"
                  label="ID Card Type"
                  rules={[
                    {
                      required: false,
                      message: "Please select the ID card type",
                    },
                  ]}
                >
                  <Select placeholder="Select ID Card Type">
                    <Option value="passport">Passport</Option>
                    <Option value="aadhaar">Aadhaar</Option>
                    <Option value="drivingLicense">Driving License</Option>
                    <Option value="voterId">Voter ID</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item
                  name="id_card_number"
                  label="ID Card Number"
                  rules={[
                    {
                      required: false,
                      message: "Please enter the ID card number",
                    },
                  ]}
                >
                  <Input placeholder="ID Card Number" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6}>
                <Form.Item
                  name="id_card_image"
                  label="ID Card Image"
                  rules={[
                    {
                      required: false,
                      message: "Please enter the ID card image",
                    },
                  ]}
                >
                  <Row gutter={[16, 16]}>
                    {imageUrl ? (
                      <Col span={12}>
                        <img
                          alt="doc-image"
                          src={IMAGE_BASE_URL + imageUrl}
                          height={150}
                          width={150}
                        />
                      </Col>
                    ) : null}
                    <Col span={imageUrl ? 12 : 24}>
                      <Dragger {...props}>
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined />
                        </p>
                      </Dragger>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
              <Col xs={24} sm={6}>
                <Form.Item
                  name="country_id"
                  label="Country"
                  rules={[
                    {
                      required: true,
                      message: "Please select the country",
                    },
                  ]}
                >
                  <Select
                    loading={loading}
                    placeholder="Select Country"
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => handleOnChange("country_id", value)}
                    options={
                      country &&
                      country.map((e) => ({
                        value: e.id,
                        label: e.name,
                      }))
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6}>
                <Form.Item
                  name="state_id"
                  label="State"
                  rules={[
                    {
                      required: false,
                      message: "Please select the State",
                    },
                  ]}
                >
                  <Select
                    loading={loading}
                    disabled={countryID === null || state === null}
                    placeholder="Select State"
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => handleOnChange("state_id", value)}
                    options={
                      state &&
                      state.map((e) => ({
                        value: e.id,
                        label: e.name,
                      }))
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={6}>
                <Form.Item
                  name="city_id"
                  label="City"
                  rules={[
                    {
                      required: false,
                      message: "Please select the City",
                    },
                  ]}
                >
                  <Select
                    loading={loading}
                    disabled={stateID === null || city === null}
                    placeholder="Select City"
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => handleOnChange("city_id", value)}
                    options={
                      city &&
                      city.map((e) => ({
                        value: e.id,
                        label: e.name,
                      }))
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={6}>
                <Form.Item
                  name="address"
                  label="Address"
                  rules={[
                    {
                      required: false,
                      message: "Please enter the address",
                    },
                  ]}
                >
                  <Input.TextArea rows={4} placeholder="Customer Address" />
                </Form.Item>
              </Col>
            </Row>
            <Row spceber>
              <Col span={24}>
                <Form.Item style={{ float: "right" }} label="" colon={false}>
                  <Button loading={loading} block htmlType="submit">
                    Update
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    </>
  );
}
export default ProfileUpdateForm;
